import _ from 'lodash';
import { useCookies } from 'react-cookie';

export const useGetGaTestId = () => {
  const [cookies] = useCookies(['_ga_ab', '_ga_abc']);

  return [_.toInteger(cookies._ga_ab), _.toInteger(cookies._ga_abc)];
};
